
<div id="wrapper">
  <div class="">
  <div class="row">
  <div class="termsWrapper">
  <h4>Refund Policy </h4>
  </div>
  <div class="termscontent-wrap">
  <p>
  Our focus is complete customer satisfaction. In the event, if you are displeased with the services
  provided, we will refund back the money, provided the reasons are genuine and proved after
  investigation. Please read the fine prints of each deal before buying it, it provides all the details
  about the services or the product you purchase.
  </p>
  <p>
  In case of dissatisfaction from our services, clients have the liberty to cancel their projects and request a refund from of us. Our Policy for the cancellation and refund will be as follow.
  </p>
  <p><strong>Cancellation Policy</strong> <br>
  For Cancellations please contact us via contact us link. <a href="mailto:care@gyandairy.com">care@gyandairy.com</a>
  Requests received later than 2 business days prior to the end of
  </p>
  <p><strong>Refund Policy</strong>
  <br>We will try our best to create the suitable design concepts for our clients
  <br>
  In case any client is not completely satisfied with our products we can provide a refund.
  <br>
  If paid by credit card, refunds will be issued to the original credit card provided at the time of
  purchase and in case of payment gateway name payments refund will be made to the same
  account.
  </p>
  </div>
  </div>
  </div>
  </div>
